<!--
 * @Description: 资源管理
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-01-25 13:14:40
 * @LastEditors: @Xin (834529118@qq.com)
 * @LastEditTime: 2021-10-27 15:41:50
 -->
<template>
  <div class="resourcesMana">
    <div class="listContainer">
      <div class="topInfo">
        <div class="listTitle">资源管理</div>
      </div>
      <div class="moduleTree">
        <el-tree
          :data="moduleTree"
          node-key="id"
          default-expand-all
          :props="moduleTreeProps"
          :expand-on-click-node="true">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span class="nodeTitle">{{ node.label }}</span>
            <span>
              <el-button
                type="text"
                size="mini"
                v-if="data.methods.length"
                class="detailBtn el-icon-document"
                @click.stop="showDetail(node, data)">
                详情
              </el-button>
              <el-button
                type="text"
                size="mini"
                :class="[data.methods.length ? 'modifyBtn el-icon-edit-outline' : 'addBtn el-icon-circle-plus-outline']"
                @click.stop="addOrModify(node, data, data.methods.length ? 'modify' : 'add')">
                {{data.methods.length ? '修改' : '新增'}}
              </el-button>
            </span>
          </span>
        </el-tree>
      </div>
    </div>
    <!-- 新增模块 弹框 start -->
    <el-dialog
      class="addDialog"
      @closed="addDialogClosed"
      :title="addDialogTitle"
      :visible.sync="addDialogVisible">
      <div class="content">
        <div class="itemTitle"><span class="required">*</span>所属模块：</div>
        <el-cascader
          v-model="moduleIdArr"
          :show-all-levels="false"
          :disabled="dialogType === 'detail'"
          clearable
          :options="moduleTree"
          :props="moduleTreeProps"
          @change="moduleChange"></el-cascader>
        <div class="itemTitle">资源权限：</div>
        <el-select v-model="methods" @change="methodsSelectChange" multiple :disabled="dialogType === 'detail'" placeholder="请选择">
          <el-option
            v-for="item in methodsOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <div class="handleArea" v-if="dialogType !== 'detail'">
          <el-button type="danger" size="medium" @click="cancelDetailDialog">取消</el-button>
          <el-button type="primary" size="medium" @click="confirmDetailDialog">{{dialogType === 'modify' ? '修改' : '新增'}}</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增模块 弹框 end -->
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'resourcesMana',
  components: {
  },
  computed: {
    ...mapState([
      'selectedSystem',
    ]),
  },
  data () {
    return {
      dialogType: '',
      // 新增资源参数start
      id: '',
      moduleId: '',
      method: '',
      path: '',
      // 新增资源参数end
      // 模块数据树
      moduleIdArr: [],
      moduleTree: [],
      moduleTreeProps: {
        checkStrictly: true,
        value: 'id',
        label: 'name',
        children: 'childs',
      },
      // 弹框
      addDialogVisible: false,
      addDialogTitle: '',
      // 权限
      methodsOptions: [],
      methods: [],
    }
  },
  watch: {
    // 监听平台选择
    async selectedSystem (val) {
      if (val !== '') {
        // 模块树
        await this.getResourceMethodAll(val)
        this.getModuleTree(val)
      }
    },
  },
  methods: {
    ...mapMutations([
      'setGlobalPlatformSelecter',
    ]),
    /**
     * @description:  获取定义的资源
     * @param {*}
     * @return {*}
     */
    getResourceMethodAll (pid) {
      return this.$http.get('/api/resource-method/all', { pid }).then(res => {
        if (res.code === 'success') {
          this.methodsOptions = res.data.list.map(v => {
            return {
              value: v.id,
              label: v.descr,
              method: v.method,
            }
          })
        }
      })
    },
    /**
     * @description             资源权限选择change事件
     * @param {Object}          当前选择
     * @return {undefined}      无返回值
     */
    methodsSelectChange (e) {
      this.method = e.join(',')
    },
    /**
     * @description             详情
     * @param {Object}          用户信息
     * @return {undefined}      无返回值
     */
    showDetail (node, data) {
      this.dialogType = 'detail'
      this.addDialogTitle = '详情'
      this.addDialogVisible = true
      this.methods = data.methods
      this.method = data.methods.join(',')
      this.path = data.path
      let modulePathArr = data.path.split('/')
      this.moduleId = modulePathArr[modulePathArr.length - 1]
      modulePathArr.map((item, index) => {
        modulePathArr[index] = parseFloat(item)
      })
      this.moduleIdArr = modulePathArr
    },
    /**
     * @description             上级模块选择change事件
     * @param {undefined}       当前选择值
     * @return {undefined}      无返回值
     */
    moduleChange (e) {
      this.path = e.join('/')
      this.moduleId = e[e.length - 1]
    },
    /**
     * @description             获取平台树形数据
     * @param {String}          平台id
     * @return {undefined}      无返回值
     */
    getModuleTree (pid) {
      const { methodsOptions } = this

      /**
       * @description:  处理tree 资源字段 将名称映射为id并返回
       * @param {Array} methods 资源列表
       * @return {Array}
       */
      const handleMethods = (methods = []) => {
        if (!methods.length) {
          return methods
        }
        return methods.map(v => {
          const findData = methodsOptions.find(({ method }) => method === v)
          return findData ? findData.value : v
        })
      }

      /**
       * @description:  递归处理tree 列表数据
       * @param {*}
       * @return {*}
       */
      const handlerModuleTree = list => {
        return list.map(({ childs, methods, ...rest }) => {
          if (childs && childs.length) {
            return {
              ...rest,
              methods: handleMethods(methods),
              childs: handlerModuleTree(childs),
            }
          }

          return {
            ...rest,
            methods: handleMethods(methods),
            childs: childs,
          }
        })
      }

      this.$http.post('/api/module/tree', { pid }).then(res => {
        if (res.code === 'success') {
          this.moduleTree = handlerModuleTree(res.data.list)
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
    /**
     * @description             修改资源
     * @param {Object}          节点node
     * @param {Object}          节点模块数据
     * @return {undefined}      无返回值
     */
    addOrModify (node, data, type) {
      this.addDialogVisible = true
      if (type === 'modify') {
        this.dialogType = 'modify'
        this.addDialogTitle = '修改'
        this.id = data.id
        this.methods = data.methods
        this.method = data.methods.join(',')
      } else if (type === 'add') {
        this.dialogType = 'add'
        this.addDialogTitle = '新增'
      }
      this.path = data.path
      let modulePathArr = data.path.split('/')
      this.moduleId = modulePathArr[modulePathArr.length - 1]
      modulePathArr.map((item, index) => {
        modulePathArr[index] = parseFloat(item)
      })
      this.moduleIdArr = modulePathArr
    },
    /**
     * @description             详情框关闭时的回调
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    addDialogClosed () {
      this.clearInfo()
    },
    /**
     * @description             置空新增参数信息
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    clearInfo () {
      this.id = ''
      this.moduleId = ''
      this.method = ''
      this.methods = []
      this.path = ''
      this.moduleIdArr = []
    },
    /**
     * @description             取消新增或修改
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    cancelDetailDialog () {
      this.addDialogVisible = false
      this.clearInfo()
    },
    /**
     * @description             确认新增或修改
     * @param {undefined}       新增时：无
     * @param {id}              修改时：id
     * @return {undefined}      无返回值
     */
    confirmDetailDialog () {
      if (!this.moduleId) {
        this.$message({
          message: '请填写完整！',
          type: 'warning',
        })
        return
      }
      let params = {
        moduleId: this.moduleId,
        methodId: this.method,
        path: this.path,
      }
      if (this.dialogType === 'modify') {
        params.id = this.id
      }
      this.$http.post('/api/resources/save', params)
        .then(res => {
          if (res.code === 'success') {
            this.$notify({
              message: this.dialogType === 'modify' ? '修改成功！' : '新增成功！',
              type: 'success',
            })
            this.addDialogVisible = false
            this.getModuleTree(this.selectedSystem)
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  async created () {
    this.setGlobalPlatformSelecter(true)
    if (this.selectedSystem) {
      await this.getResourceMethodAll(this.selectedSystem)
      // 部门树
      this.getModuleTree(this.selectedSystem)
    }
  },
}
</script>

<style lang="less" scoped>
  .resourcesMana {
    width: 100%;
    height: 100%;
    .listContainer {
      width: 100%;
      height: calc(100% - 50px);

      .topInfo {
        width: calc(100% - 40px);
        height: 50px;
        line-height: 50px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        .listTitle {
          font-size: 26px;
          font-weight: bold;
        }
      }

      .moduleTree {
        padding: 30px 150px;
        width: calc(100% - 300px);
        height: calc(100% - 60px);
        overflow-y: scroll;
        /deep/ .el-tree {
          .el-tree-node {
            .el-tree-node__content {
              .custom-tree-node {
                .nodeTitle {
                  margin-right: 50px;
                }
              }
              .el-tree-node__expand-icon {
                font-size: 20px;
              }
              .is-leaf {
                opacity: 1;
              }
            }
            .el-icon-circle-plus-outline {
              color: #67C23A;
              &:hover {
                color: #a0e07f;
              }
            }
            .addBtn {
              color: #67C23A;
              &:hover {
                color: #a0e07f;
              }
            }
            .modifyBtn {
              color: #E6A23C;
              &:hover {
                color: #f5be6d;
              }
            }
            .deleteBtn {
              color: #F56C6C;
              &:hover {
                color: #f59595;
              }
            }
          }
        }
      }
    }
    /deep/.addDialog {
      .el-dialog {
        width: 480px;
        height: 320px;
        border-radius: 6px;
        .el-dialog__header {
          background: #2c63a3;
          border-radius: 6px 6px 0 0;
          padding: 10px 20px;
          .el-dialog__title {
            color: #fff;
          }
          .el-dialog__headerbtn {
            top: 10px;
            .el-dialog__close {
              color: #fff;
              font-size: 26px;
            }
          }
        }
        .el-dialog__body {
          height: calc(100% - 84px);
          padding: 20px;
          .content {
            width: 100%;
            height: 100%;
            position: relative;
            .itemTitle {
              font-size: 16px;
              color: #666;
              margin: 10px 0;
              .required {
                color: #F56C6C;
                margin-right: 6px;
                vertical-align: middle;
              }
            }
            .el-input {
              width: 320px;
            }

            .handleArea {
              text-align: right;
              position: absolute;
              bottom: 0;
              right: 0;
            }
          }
        }
      }
    }
  }
</style>
